module.exports = __webpack_public_path__ + "static/media/master-card.deddf9c9.svg";